import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import {
    ORGANIZATION_PREFERENCES,
    PREFERENCE_EMPTY_STATE,
} from "../../utils/constants";
import {
    getReactSelectStyling,
    getReactSelectTheme,
} from "../../utils/ReactSelectStyles";
import LocalizedLablesCard from "../Cards/LocalizedLablesCard";
import Select from "react-select";
import ValidationError from "../Shared/ValidationError";

const OrganizationPreferencesForm = ({
    input,
    setInput,
    isFormSubmitted,
    error,
}) => {
    // General states
    const { t } = useTranslation();
    const [apiLanguages, setApiLanguages] = useState({});

    // Use effects
    useEffect(() => {
        if (!input?.preferences || !input?.preferences?.length) {
            setInput((prevInput) => ({
                ...prevInput,
                preferences: [{ ...PREFERENCE_EMPTY_STATE }],
            }));
        }
    }, [input]);

    // Handlers
    const handleOnChange = (name, value, index) => {
        setInput((prevInput) => {
            const newPreferences = [...prevInput.preferences];
            newPreferences[index][name] = value;
            return {
                ...prevInput,
                preferences: newPreferences,
            };
        });
    };

    const getEntityOptions = () => {
        return Object.values(ORGANIZATION_PREFERENCES).filter(
            (elem) =>
                !input.preferences.find(
                    (inputElem) => inputElem?.entity?.value === elem.value
                )
        );
    };

    const getEntityValue = (preference) => {
        if (typeof preference.entity === "string")
            return Object.values(ORGANIZATION_PREFERENCES).find(
                (elem) => elem.value === preference.entity
            );
        else return preference.entity;
    };

    const handleAddPreference = () => {
        setInput((prevInput) => ({
            ...prevInput,
            preferences: [
                ...prevInput.preferences,
                { ...PREFERENCE_EMPTY_STATE },
            ],
        }));
    };

    const handleResetPreference = (index) => {
        setInput((prevInput) => {
            let preferences = [...prevInput.preferences];
            preferences[index] = { ...PREFERENCE_EMPTY_STATE };

            return {
                ...prevInput,
                preferences,
            };
        });
    };

    return (
        <div className="pt-4">
            <header className="main-content-header flex justify-between items-center">
                <h2 className="h2">
                    <Trans i18nKey="preferences">Preferences</Trans>
                </h2>
            </header>
            <div className="flex flex-col gap-2">
                {!isEmpty(input.preferences) &&
                    input.preferences.map((preference, index) => (
                        <div
                            key={index}
                            className="flex w-full items-center item-list grey-list m-0"
                        >
                            <div className="flex flex-col w-full pt-3">
                                <div className="items flex justify-between">
                                    <div className="input-group w-full">
                                        <div className="tags pl-3 pb-3 whitespace-wrap">
                                            <h4 className="uppercase text-xs">
                                                <Trans i18nKey="entity">
                                                    Entity
                                                </Trans>
                                            </h4>
                                            <Select
                                                options={getEntityOptions()}
                                                value={getEntityValue(
                                                    preference
                                                )}
                                                onChange={(value) => {
                                                    handleOnChange(
                                                        "entity",
                                                        value,
                                                        index
                                                    );
                                                }}
                                                placeholder={t(
                                                    "entityPlaceholder"
                                                )}
                                                styles={getReactSelectStyling()}
                                                theme={getReactSelectTheme}
                                            />
                                            {isFormSubmitted && (
                                                <ValidationError
                                                    errorMessage={
                                                        error[
                                                            `preferences.${index.toString()}.entity`
                                                        ]
                                                    }
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="px-3">
                                    <LocalizedLablesCard
                                        localizations={
                                            preference?.localizations
                                        }
                                        apiLanguages={apiLanguages}
                                        setApiLanguages={setApiLanguages}
                                        setLocalizations={(val) =>
                                            handleOnChange(
                                                "localizations",
                                                val,
                                                index
                                            )
                                        }
                                        mainLanguageErrorMessage={
                                            isFormSubmitted &&
                                            error[
                                                `preferences.${index.toString()}.localizations.en`
                                            ]
                                        }
                                        isFieldDisabled={
                                            !getEntityValue(preference)
                                        }
                                        label={t("localizations")}
                                        primaryButtonColor="text-primary-color-dark-blue"
                                        secondActionButton={{
                                            label: t("reset"),
                                            disabled: !(
                                                preference?.entity ||
                                                preference?.localizations.en
                                            ),
                                            handler: () =>
                                                handleResetPreference(index),
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                <div className="flex justify-end p-2">
                    <span
                        onClick={handleAddPreference}
                        className={`cursor-pointer text-primary-color-dark-blue text-xs ${
                            input?.preferences?.length ===
                            Object.values(ORGANIZATION_PREFERENCES).length
                                ? "disabled"
                                : ""
                        }`}
                    >
                        <i className="fas fa-plus fa-xs mr-1"></i>
                        <Trans i18nKey="addPreference">Add Preference</Trans>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default OrganizationPreferencesForm;
